const steps = [
  { name: "Onboarding Steps", time: "(2-4 hours)"},
  { name: "Wait to get matched" },
];

export default steps;
